import { Payor } from '../../types';
import { PayorType } from '../constants';

export const getInitialPayorData = (type: PayorType, payorIndex?: number): Payor => {
  const id = payorIndex !== undefined ? `payor-${payorIndex}` : `payor-${Date.now()}`;

  if (type === PayorType.INDIVIDUAL) {
    return {
      id,
      type: PayorType.INDIVIDUAL,
      firstName: '',
      middleName: '',
      lastName: '',
      suffix: '',
    };
  } else {
    return {
      id,
      type: PayorType.ENTITY,
      legalName: '',
    };
  }
};

export const validatePayor = (payor: Payor): boolean => {
  if (payor.type === PayorType.INDIVIDUAL) {
    return !!payor.firstName && !!payor.lastName;
  } else if (payor.type === PayorType.ENTITY) {
    return !!payor.legalName;
  }
  return false;
};
